'use Client'

import { RefObject, useEffect, useRef, useState } from "react";
import css from "./SlideText.module.scss"

import 'swiper/css';
import 'swiper/css/navigation';
import "swiper/css/autoplay";
import { Swiper, SwiperSlide } from "swiper/react";
import { Autoplay } from "swiper/modules";
import clsx from "clsx";

interface Props<T extends HTMLElement> {
    coverRef: RefObject<T | null>;
    text: string
    speed?: number
    betweenDivisor?: number
    fontSize?: number
    autoSlide?: boolean
}

function SlideText<T extends HTMLElement>({
    coverRef,
    text,
    speed = 5000,
    betweenDivisor = 2,
    fontSize = 16,
    autoSlide = false
}: Props<T>) {
    const textRef = useRef<HTMLDivElement>(null)

    const [animation, setAnimation] = useState<boolean>(false)
    const [between, setBetween] = useState<number>(0)
    const [slideWidth, setSlideWidth] = useState<number>(0)
    const [isComplete, setIsComplete] = useState<boolean>(false)

    useEffect(() => {
        if (!coverRef.current || !textRef.current) return;

        const cover = coverRef.current
        const text = textRef.current

        const isShort: boolean = text.clientWidth < cover.clientWidth * 0.6
        
        setSlideWidth(()=> {
            if(isShort){
                // 내용이 짧을 경우 최대값 지정
                return cover.clientWidth * 0.6
            }else{
                return text.clientWidth
            }
        })

        let setBetweenLength: number = isShort ? 1 : text.clientWidth / betweenDivisor
        if(setBetweenLength > 120) {
            setBetweenLength = 120
        }
        if (autoSlide) {
            setBetween(setBetweenLength)
            setAnimation(true);
        }else{
            if (cover.clientWidth < text.clientWidth) {
                setBetween(setBetweenLength)
                setAnimation(true)
            } else {
                setAnimation(false)
            }
        }

        setTimeout(()=> {
            setIsComplete(true)
        }, 1000)
    }, [text])

    return (
        <>
            <div ref={textRef} className={clsx(css.hidden, isComplete && css.complete)} style={{ fontSize: `${fontSize}px` }} dangerouslySetInnerHTML={{__html: text}}></div>
            {
                animation && slideWidth
                    ? <>
                        <Swiper
                            modules={[Autoplay]}
                            loop={true}
                            spaceBetween={between || 40}
                            slidesPerView="auto"
                            speed={speed}
                            autoplay={{
                                delay: 0,                    // 자동 전환
                            }}
                        >
                            <SwiperSlide style={{width: `${slideWidth}px`}}>
                                <Text className="loop" text={text} fontSize={fontSize} />
                            </SwiperSlide>
                            <SwiperSlide style={{width: `${slideWidth}px`}}>
                                <Text className="loop" text={text} fontSize={fontSize} />
                            </SwiperSlide>
                            <SwiperSlide style={{width: `${slideWidth}px`}}>
                                <Text className="loop" text={text} fontSize={fontSize} />
                            </SwiperSlide>
                        </Swiper>
                    </>
                    : <Text className="normal" text={text} fontSize={fontSize} />
            }
        </>
    )
}

export default SlideText;

interface TextProps {
    className: string
    text: string
    fontSize: number
}
function Text({className, text, fontSize=16}: TextProps){
    return (
        <div className={css[className]} 
             style={{ fontSize: `${fontSize}px` }} 
             dangerouslySetInnerHTML={{__html: text}} />
    )
}